import getAPIResponse from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';
import { ImprovementProposal } from '../Model/ImprovementProposal';

export async function getImprovementProposal(id) {
  const response = await getAPIResponse(`/v1/improvement-proposal/${id}`);
  if (response === null) return null;
  try {
    return ImprovementProposal.createFromResponseData(response);
  } catch (e) {
    return null;
  }
}
